var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.0) scale(0.857143)"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    rx: 14,
    width: 28,
    height: 28,
    fill: "currentColor",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 8,
    y: 8,
    rx: 6,
    width: 12,
    height: 12,
    fill: "#fff",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selectedIcon.e4b34b6cd7475833119e78930f4d4ee4.svg";
export { ForwardRef as ReactComponent };